import { createContext, useContext } from 'react';
export const DocumentListPageContext = createContext({
    basePath: '/portal/documents',
    toUserPath: () => '',
    toFilePath: () => ''
});
export function useDocumentListPageContext() {
    const context = useContext(DocumentListPageContext);
    if (!context) {
        throw new Error('useDocumentListPageContext must be used within the DocumentListPageProvider component');
    }
    return context;
}
//# sourceMappingURL=DocumentListPageContext.js.map